/*!
  =========================================================
  * Vue Paper Dashboard - v2.0.0
  =========================================================
  * Product Page: http://www.creative-tim.com/product/paper-dashboard
  * Copyright 2019 Creative Tim (http://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from './store/index';

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

/* add yarn import */
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from "./config.js"
import moment from 'moment'

import vueXstore from '@/store/index';
import VueClipboard from 'vue-clipboard2'

import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

// ref. https://www.npmjs.com/package/vue-html2canvas
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);

Vue.use(PaperDashboard);
Vue.prototype.moment = moment

// facebook page
import VueFacebookPage from 'vue-facebook-page'
Vue.use(VueFacebookPage, 279855888709461/** Add your facebook appId here */)

// gaTag page
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-179956144-1',
  router,
})

// text-editor
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// Vue.use(VueQuillEditor, /* { default global options } */)
// Vue.prototype.$liff = Window.liff

// tag input
import InputTag from 'vue-input-tag'
Vue.component('input-tag', InputTag)

// Configure axios
axios.defaults.baseURL = config.apiUrl
Vue.use(VueAxios, axios)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

/* eslint-disable no-new */
/*
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
*/

router.beforeEach((to, from, next) => {
  window.location.href = 'https://newmy.muic.io/'
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})